import { SxProps, Theme } from '@mui/material';

export type GridSizeType = {
  xs: number;
  sm: number;
  md: number;
  lg: number;
};

const gridSizeXsSm12 = {
  xs: 12,
  sm: 12,
};

export const gridSize0 = {
  xs: 0,
  sm: 0,
  md: 0,
  lg: 0,
};

export const gridSize = {
  ...gridSizeXsSm12,
  md: 12,
  lg: 12,
};

export const gridSizeMdLg1 = {
  ...gridSizeXsSm12,
  md: 1,
  lg: 1,
};

export const gridSizeMdLg2 = {
  ...gridSizeXsSm12,
  md: 2,
  lg: 2,
};

export const gridSizeMdLg3 = {
  ...gridSizeXsSm12,
  md: 3,
  lg: 3,
};
export const gridSizeMdLg4 = {
  ...gridSizeXsSm12,
  md: 4,
  lg: 4,
};

export const gridSizeMdLg5 = {
  ...gridSizeXsSm12,
  md: 5,
  lg: 5,
};

export const gridSizeMdLg6 = {
  ...gridSizeXsSm12,
  md: 6,
  lg: 6,
};

export const gridSizeMdLg7 = {
  ...gridSizeXsSm12,
  md: 7,
  lg: 7,
};

export const gridSizeMdLg8 = {
  ...gridSizeXsSm12,
  md: 8,
  lg: 8,
};

export const gridSizeMdLg9 = {
  ...gridSizeXsSm12,
  md: 9,
  lg: 9,
};

export const gridSizeMdLg10 = {
  ...gridSizeXsSm12,
  md: 10,
  lg: 10,
};

export const gridSizeMdLg11 = {
  ...gridSizeXsSm12,
  md: 11,
  lg: 11,
};

export const gridSizeMdLg12 = {
  ...gridSizeXsSm12,
  md: 12,
  lg: 12,
};
export const gridSizeConst1 = { xs: 1, lg: 1, md: 1, sm: 1 }
export const gridSizeConst2 = { xs: 2, lg: 2, md: 2, sm: 2 }
export const gridSizeConst3 = { xs: 3, lg: 3, md: 3, sm: 3 }
export const gridSizeConst4 = { xs: 4, lg: 4, md: 4, sm: 4 }
export const gridSizeConst5 = { xs: 5, lg: 5, md: 5, sm: 5 }
export const gridSizeConst6 = { xs: 6, lg: 6, md: 6, sm: 6 }
export const gridSizeConst8 = { xs: 8, lg: 8, md: 8, sm: 8 }
export const gridSizeConst9 = { xs: 9, lg: 9, md: 9, sm: 9 }
export const gridSizeConst10 = { xs: 10, lg: 10, md: 10, sm: 10 }
export const gridSizeConst11 = { xs: 11, lg: 11, md: 11, sm: 11 }
export const gridSizeConst12 = { xs: 12, lg: 12, md: 12, sm: 12 }

export const sizeTab = { xs: 370, sm: 480, md: 900, lg: 1200 };
export const sizeBoxTab = { xs: 370, sm: 480, md: 600, lg: 800 };

export type JustifyContentType =
  | 'flex-start'
  | 'center'
  | 'flex-end'
  | 'space-between'
  | 'space-around'
  | 'space-evenly'
  | 'stretch'
  | 'baseline'
  | 'start'
  | 'end';

export type SxType = SxProps<Theme>;

export type ColorTypeButton =
  | 'default'
  | 'error'
  | 'info'
  | 'inherit'
  | 'primary'
  | 'secondary'
  | 'success'
  | 'warning';

export const tabTextLabelSx = {
  display: 'flex',
  alignItems: 'start',
  justifyContent: 'start',
  width: '100%',
  pt: '0px',
  pl: '24px',
  mt: '15px',
  pb: '24px',
  fontSize: '.9rem',
  color: '#6c737fb0',
};

export type SxPropsThemeType = SxProps<Theme>;

export type BtnColorType =
  | 'primary'
  | 'secondary'
  | 'error'
  | 'info'
  | 'success'
  | 'inherit'
  | 'warning';

export const TABLE_CONSTANTS_COLUMS = {
  ACTIONCOLUMN_WIDTH: 102,
  COLUMN_WIDTH_SMALL: 111,
  COLUMN_WIDTH_MEDIUM: 170,
  COLUMN_WIDTH_LARGE: 300,
};
